import { Box, CircularProgress } from "@mui/material";

export default function FieldLoader() {
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: theme.palette.grey[200],
          ...theme.applyStyles("dark", {
            color: theme.palette.grey[800],
          }),
        })}
        size={40}
        thickness={6}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
        })}
        size={40}
        thickness={6}
      />
    </Box>
  );
}
